import {DataTable} from "../DataTable/DataTable";
import {StatisticsGroupWrapper, StatisticsType, TransportCategory, TransportMethod} from "@ots-frontend/ots-data";
import {useStatisticsDataTableColumns} from "./useStatisticsDataTableColumns";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";

const EMPTY_ARRAY: StatisticsGroupWrapper[] = []

export type StatisticsChildDataTableProps = Omit<EntityDataTableProps<StatisticsGroupWrapper>, 'recordsPerPageOptions'>
  & {
  expandedIds?: string[]
  rateModel?: string
  category?: TransportCategory
  method?: TransportMethod
  types: StatisticsType[]
}

export const StatisticsChildDataTable = (props: StatisticsChildDataTableProps) => {
  const {
    records: data = EMPTY_ARRAY,
    expandedIds,
    rateModel,
    category,
    method,
    types,
    ...rest
  } = props;

  const {
    columns,
  } = useStatisticsDataTableColumns({
    expandedIds: expandedIds,
    nestLevel: 1,
    rateModel: rateModel,
    category: category,
    method: method,
    types: types,
  })

  return (
    <DataTable
      {...rest}
      records={data}
      columns={columns}
    />
  );
}
